/**
 * postLogin.js — marca de "ingreso en curso" para la ruta raíz.
 *
 * Varios flujos de login terminan aterrizando en "/" y esperan que la app los mande al
 * dashboard: el retorno de OAuth (Supabase `redirectTo`), el `fallbackRedirectUrl` de Clerk y
 * `establecer-password`. Antes, "/" redirigía SIEMPRE que hubiera sesión, así que un usuario
 * logueado no podía volver a ver la landing escribiendo la dirección principal.
 *
 * Con esta marca el redirect queda acotado a esos flujos: se setea justo antes de salir hacia
 * el proveedor (o de navegar a "/") y `AuthRedirect` la consume una sola vez. Sin marca, "/"
 * muestra la landing aunque haya sesión abierta.
 */
const KEY = 'cd_ingreso_en_curso'

export function marcarIngresoEnCurso() {
  // sessionStorage puede lanzar (modo privado, cookies bloqueadas): no romper el login por esto.
  try { sessionStorage.setItem(KEY, '1') } catch { /* sin marca → cae en la landing */ }
}

/** Lee y BORRA la marca (un solo uso) → una marca huérfana no redirige para siempre. */
export function consumirIngresoEnCurso() {
  try {
    const hay = sessionStorage.getItem(KEY) === '1'
    if (hay) sessionStorage.removeItem(KEY)
    return hay
  } catch { return false }
}

/**
 * Decide qué hacer en la ruta raíz. Pura y sin React para poder testear las 4 combinaciones
 * (la landing y el dashboard son estados excluyentes que dependen de la sesión).
 *
 *  'dashboard' → seguir al panel del tenant (sólo si este "/" es el aterrizaje de un login)
 *  'espera'    → spinner: hay un login en curso pero la sesión todavía se está hidratando
 *                (mostrar la landing acá causaba el "flash" landing → dashboard)
 *  'landing'   → landing pública; es el default, incluso con sesión abierta
 */
export function decidirRaiz({ volviendoDeLogin, isAuthenticated, slug, cargando }) {
  if (!volviendoDeLogin) return 'landing'
  if (isAuthenticated && slug) return 'dashboard'
  return cargando ? 'espera' : 'landing'
}
